import { MetricGroup } from 'types'

export function transformMetricGroups(metricGroups: MetricGroup[]): MetricGroup[] {
  return metricGroups.map((metricGroup) => {
    const absoluteMetrics: Record<string, string | number>[] = []
    const perCapitaMetrics: Record<string, string | number>[] = []

    metricGroup.metrics.forEach((metric) => {
      const formattedMetricName = metric.metric_name
        .toString()
        .replace(/^Number of /, '')
        .replace(/ PC$/, '')

      const metricObject: Record<string, string | number> = {
        [metric.shortname_raw]: formattedMetricName,
      }

      if (metric.shortname_raw.toString().startsWith('pc_')) {
        perCapitaMetrics.push(metricObject)
      } else {
        absoluteMetrics.push(metricObject)
      }
    })

    return {
      ...metricGroup,
      metricList: {
        absolute: absoluteMetrics,
        perCapita: perCapitaMetrics,
      },
    }
  })
}
